import appConfig from '../../../../config/appConfig';
import iotDeviceFeatureConfigService from '../../../../services/iotDevice/iotDeviceFeatureConfigService';
import iotDeviceGlobalConfigService from '../../../../services/iotDevice/iotDeviceGlobalConfigService';
import iotDeviceSettingsService from '../../../../services/iotDevice/iotDeviceSettingsService';
import productService from '../../../../services/product/productService';

const useDeviceDiagnosticModeEnabled = (iotDevice) => {
    const {device, holder} = iotDevice || {};
    const {isHolderConnected, status: deviceStatus, deviceSerialNumber} = device || {};
    const isDeviceRegistered = deviceSerialNumber ? productService.getIsRegistered(deviceStatus) : true;
    const isHolderRegistered = isHolderConnected && holder ? productService.getIsRegistered(holder.status) : true;
    const isRegistrationPromoted = appConfig.getIsRegistrationPromoted();
    const isEnabled = (isDeviceRegistered && isHolderRegistered) || isRegistrationPromoted;

    const isGlobalAdvancedDiagnostic = isEnabled && iotDeviceGlobalConfigService.isGlobalAdvancedDiagnostic(iotDevice);
    const isFeatureAdvancedDiagnostic = iotDeviceFeatureConfigService.isAdvancedDiagnostic();

    const isAdvancedDeviceDiagnosticModeEnabled = iotDeviceSettingsService.isSettingAvailable(
        iotDevice,
        isGlobalAdvancedDiagnostic,
        isFeatureAdvancedDiagnostic
    );

    const isGlobalConnectCare = isEnabled && iotDeviceGlobalConfigService.isGlobalConnectCare(iotDevice);
    const isFeatureConnectCare = iotDeviceFeatureConfigService.isConnectCareModeEnabled();

    const isConnectCareModeEnabled =
        !isAdvancedDeviceDiagnosticModeEnabled &&
        iotDeviceSettingsService.isSettingAvailable(iotDevice, isGlobalConnectCare, isFeatureConnectCare);

    return {isConnectCareModeEnabled, isAdvancedDeviceDiagnosticModeEnabled};
};

export default useDeviceDiagnosticModeEnabled;
